import { render, staticRenderFns } from "./wrap.vue?vue&type=template&id=d8fb1860"
import script from "./wrap.vue?vue&type=script&lang=js"
export * from "./wrap.vue?vue&type=script&lang=js"
import style0 from "./wrap.vue?vue&type=style&index=0&id=d8fb1860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports